import { Box, useTheme } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux';
import { IRootState } from '../../store/reducer';

const DescriptionComponent = () => {
  const theme = useTheme();
  const description = useSelector((state: IRootState) => state.pickemOptimizer.description);
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginTop: 4,
      backgroundColor: '#101010',
      [theme.breakpoints.down('xs')]: {
        marginTop: 0,
      },
    }}>
      <Box
        sx={{
          backgroundColor: '#101010',
          fontSize: '1rem',
          lineHeight: 1.7,
          fontWeight: 400,
          [theme.breakpoints.down('md')]: {
            padding: '0 24px',
          },
          color: theme.palette.common.black,
          '& a': {
            cursor: 'pointer',
            color: theme.palette.common.white,
            fontWeight: 500,
          },
          '& ol': {
            paddingLeft: 16
          },
          '& li': {
            color: theme.palette.common.white,
          },
          '& h1': {
            color: theme.palette.common.white,
          },
          '& h2': {
            color: theme.palette.common.white,
          },
          '& h3': {
            color: theme.palette.common.white,
          },
          '& h4': {
            color: theme.palette.common.white,
          },
          '& h5': {
            color: theme.palette.common.white,
          },
          '& p': {
            color: theme.palette.common.white,
          }
        }}
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </Box>
  )
}

export default DescriptionComponent